module.exports = __webpack_public_path__ + "img/program_added.28670fb0.svg";